const config = {
    'test': '',
    'AGENT_FLOW_API_MAPPING': {
'fk:RIDERVERIFICATION_SELFIE_INITIATE': 'https://workflowpieces-gam.shipsy.io/api/webhook/rider-verification-selfie-initiate/fk',
'fk:RIDERVERIFICATION_AADHAAR_VERIFY': 'https://workflowpieces-gam.shipsy.io/api/webhook/rider-verification-aadhaar-verify/fk',
'fk:RIDERVERIFICATION_DIGILOCKER_INITIATE': 'https://workflowpieces-gam.shipsy.io/api/webhook/rider-verification-digilocker-initiate/fk',
    },
    'RETURNABLE_ASSETS_RECON_WORKFLOW_URL_MAPPING': {
        'fk:RETURNABLE_ASSETS_RECON_WORKFLOW': 'https://workflowpieces-gam.shipsy.io/api/webhook/returnable-asset-drop-zone-attempt/fk',
        'fkdemo:RETURNABLE_ASSETS_RECON_WORKFLOW': 'https://workflowpieces-gam.shipsy.io/api/webhook/returnable-asset-drop-zone-attempt/fkdemo',
    },
};
module.exports = config;
